if (typeof AnnouncementBar !== 'function') {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');
      this.index = 0;
      this.length = this.content.length;
      this.autoScrollInterval = null;

      if (this.length > 1) {
        this.init();
      }
    }

    init() {
      this.updateButtons();
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }
      this.startAutoScroll();
    }

    updateButtons() {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      if (this.index === this.length - 1) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else if (this.index === 0) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      }
    }

    changeSlide(direction) {
      if (direction === 'next') {
        this.index = (this.index + 1) % this.length; // Loop back to 0
      } else if (direction === 'prev') {
        this.index = this.index - 1 < 0 ? this.length - 1 : this.index - 1; // Loop to end
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

      this.updateButtons();
      this.resetAutoScroll();
    }

    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.changeSlide('next');
      }, 3000); // 10 seconds
    }

    resetAutoScroll() {
      clearInterval(this.autoScrollInterval);
      this.startAutoScroll();
    }

    disconnectedCallback() {
      clearInterval(this.autoScrollInterval);
    }
  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }
}